export const mockGroupedAuthSequences = [
  {
    locationId: 200,
    locationIdName: '200',
    locationNameLong: 'KANSAS CITY',
    products: [
      {
        loadingAllowed: true,
        notSequenced: [],
        productId: 154927,
        productIdName: 'E',
        productNameLong: '12 87 OCTANE 10E90V P66',
        sequenced: [
          {
            futureSequenceDate: '2026-05-14',
            inventoryOwner: '410 PHILLIPS66',
            isActive: true,
            productAuthorizationId: 12718,
            sequenceNumber: 1,
            supplierDirectedBlend: true,
          },
        ],
      },
      {
        loadingAllowed: true,
        notSequenced: [],
        productId: 110,
        productIdName: 'A',
        productNameLong: 'A PREMIUM UNLEADED GASOLINE',
        sequenced: [
          {
            futureSequenceDate: null,
            inventoryOwner: '410 PHILLIPS66',
            isActive: true,
            productAuthorizationId: 12718,
            sequenceNumber: 1,
            supplierDirectedBlend: false,
          },
        ],
      },
      {
        loadingAllowed: true,
        notSequenced: [
          {
            futureSequenceDate: null,
            inventoryOwner: '515 MARATHON PETROLEUM',
            isActive: true,
            productAuthorizationId: 12720,
            sequenceNumber: null,
            supplierDirectedBlend: false,
          },
        ],
        productId: 120,
        productIdName: 'D',
        productNameLong: 'D DIESEL FUEL',
        sequenced: [
          {
            futureSequenceDate: null,
            inventoryOwner: '410 PHILLIPS66',
            isActive: true,
            productAuthorizationId: 12719,
            sequenceNumber: 1,
            supplierDirectedBlend: false,
          },
          {
            futureSequenceDate: null,
            inventoryOwner: '320 BP PRODUCTS',
            isActive: true,
            productAuthorizationId: 12721,
            sequenceNumber: 2,
            supplierDirectedBlend: true,
          },
        ],
      },
      {
        loadingAllowed: false,
        notSequenced: [],
        productId: 125,
        productIdName: 'E10',
        productNameLong: 'E10 ETHANOL BLEND',
        sequenced: [
          {
            futureSequenceDate: '2026-12-15',
            inventoryOwner: '610 VALERO ENERGY',
            isActive: false,
            productAuthorizationId: 12722,
            sequenceNumber: 1,
            supplierDirectedBlend: false,
          },
        ],
      },
      {
        loadingAllowed: true,
        notSequenced: [],
        productId: 130,
        productIdName: 'JET',
        productNameLong: 'JET FUEL A1',
        sequenced: [
          {
            futureSequenceDate: null,
            inventoryOwner: '410 PHILLIPS66',
            isActive: true,
            productAuthorizationId: 12723,
            sequenceNumber: 1,
            supplierDirectedBlend: false,
          },
          {
            futureSequenceDate: null,
            inventoryOwner: '320 BP PRODUCTS',
            isActive: true,
            productAuthorizationId: 12724,
            sequenceNumber: 2,
            supplierDirectedBlend: false,
          },
          {
            futureSequenceDate: null,
            inventoryOwner: '515 MARATHON PETROLEUM',
            isActive: false,
            productAuthorizationId: 12725,
            sequenceNumber: 3,
            supplierDirectedBlend: false,
          },
        ],
      },
    ],
  },
  {
    locationId: 208,
    locationIdName: '208',
    locationNameLong: 'MANKATO',
    products: [
      {
        loadingAllowed: false,
        notSequenced: [
          {
            futureSequenceDate: null,
            inventoryOwner: '211 FLINT HILLS RES',
            isActive: false,
            productAuthorizationId: 7166,
            sequenceNumber: null,
            supplierDirectedBlend: false,
          },
        ],
        productId: 110,
        productIdName: 'A',
        productNameLong: 'A PREMIUM UNLEADED GASOLINE',
        sequenced: [],
      },
      {
        loadingAllowed: true,
        notSequenced: [
          {
            futureSequenceDate: null,
            inventoryOwner: '515 MARATHON PETROLEUM',
            isActive: true,
            productAuthorizationId: 7168,
            sequenceNumber: null,
            supplierDirectedBlend: true,
          },
          {
            futureSequenceDate: null,
            inventoryOwner: '610 VALERO ENERGY',
            isActive: true,
            productAuthorizationId: 7169,
            sequenceNumber: null,
            supplierDirectedBlend: false,
          },
        ],
        productId: 115,
        productIdName: 'R',
        productNameLong: 'R REGULAR UNLEADED GASOLINE',
        sequenced: [
          {
            futureSequenceDate: null,
            inventoryOwner: '211 FLINT HILLS RES',
            isActive: true,
            productAuthorizationId: 7167,
            sequenceNumber: 1,
            supplierDirectedBlend: false,
          },
        ],
      },
      {
        loadingAllowed: true,
        notSequenced: [],
        productId: 120,
        productIdName: 'D',
        productNameLong: 'D DIESEL FUEL',
        sequenced: [
          {
            futureSequenceDate: null,
            inventoryOwner: '211 FLINT HILLS RES',
            isActive: true,
            productAuthorizationId: 7170,
            sequenceNumber: 1,
            supplierDirectedBlend: false,
          },
          {
            futureSequenceDate: null,
            inventoryOwner: '410 PHILLIPS66',
            isActive: true,
            productAuthorizationId: 7171,
            sequenceNumber: 2,
            supplierDirectedBlend: false,
          },
        ],
      },
      {
        loadingAllowed: false,
        notSequenced: [
          {
            futureSequenceDate: null,
            inventoryOwner: '320 BP PRODUCTS',
            isActive: false,
            productAuthorizationId: 7172,
            sequenceNumber: null,
            supplierDirectedBlend: true,
          },
        ],
        productId: 135,
        productIdName: 'B20',
        productNameLong: 'B20 BIODIESEL BLEND',
        sequenced: [],
      },
    ],
  },
];

// Mock data for authorization sequences
export const mockAuthSequences = [
  {
    loadingAllowed: true,
    locationId: 1,
    nameLong: 'Houston Terminal - North Facility',
    notSequenced: [
      {
        inventoryOwner: 'Global Industries',
        isActive: true,
        productAuthorizationId: 101,
        sequenceNumber: 0,
        supplierDirectedBlend: false,
      },
    ],
    product: {
      nameLong: 'Premium Diesel',
    },
    productId: 201,
    sequenced: [
      {
        inventoryOwner: 'Apex Crude Corp',
        isActive: true,
        productAuthorizationId: 201,
        sequenceNumber: 1,
        supplierDirectedBlend: false,
      },
      {
        inventoryOwner: 'TechStart Inc',
        isActive: true,
        productAuthorizationId: 202,
        sequenceNumber: 2,
        supplierDirectedBlend: true,
      },
    ],
    testStatus: 'error',
  },
  {
    loadingAllowed: true,
    locationId: 1,
    nameLong: 'Houston Terminal - North Facility',
    notSequenced: [],
    product: {
      nameLong: 'Gasoline 87',
    },
    productId: 207,
    sequenced: [
      {
        inventoryOwner: 'Apex Crude Corp',
        isActive: true,
        productAuthorizationId: 203,
        sequenceNumber: 1,
        supplierDirectedBlend: false,
      },
      {
        inventoryOwner: 'TechStart Inc',
        isActive: true,
        productAuthorizationId: 204,
        sequenceNumber: 2,
        supplierDirectedBlend: false,
      },
      {
        inventoryOwner: 'Global Industries',
        isActive: false,
        productAuthorizationId: 205,
        sequenceNumber: 3,
        supplierDirectedBlend: false,
      },
    ],
    testStatus: 'success',
  },
  {
    loadingAllowed: false,
    locationId: 1,
    nameLong: 'Houston Terminal - North Facility',
    notSequenced: [
      {
        inventoryOwner: 'Horizon Trading',
        isActive: true,
        productAuthorizationId: 105,
        sequenceNumber: 0,
        supplierDirectedBlend: false,
      },
    ],
    product: {
      nameLong: 'Diesel',
    },
    productId: 208,
    sequenced: [
      {
        inventoryOwner: 'Innovative Solutions',
        isActive: false,
        productAuthorizationId: 206,
        sequenceNumber: 1,
        supplierDirectedBlend: false,
      },
    ],
    testStatus: 'progress',
  },
  {
    futureSequenceDate: '2026-12-01',
    loadingAllowed: false,
    locationId: 2,
    nameLong: 'Dallas-Fort Worth Complex',
    notSequenced: [],
    product: {
      nameLong: 'Gasoline 87',
    },
    productId: 202,
    sequenced: [
      {
        inventoryOwner: 'Innovative Solutions',
        isActive: false,
        productAuthorizationId: 207,
        sequenceNumber: 1,
        supplierDirectedBlend: false,
      },
    ],
  },
  {
    loadingAllowed: true,
    locationId: 2,
    nameLong: 'Dallas-Fort Worth Complex',
    notSequenced: [],
    product: {
      nameLong: 'Ethanol Blend',
    },
    productId: 209,
    sequenced: [
      {
        inventoryOwner: 'TechStart Inc',
        isActive: true,
        productAuthorizationId: 208,
        sequenceNumber: 1,
        supplierDirectedBlend: true,
      },
      {
        inventoryOwner: 'Summit Logistics',
        isActive: true,
        productAuthorizationId: 209,
        sequenceNumber: 2,
        supplierDirectedBlend: false,
      },
    ],
  },
  {
    loadingAllowed: true,
    locationId: 3,
    nameLong: 'Terminal 3 - Austin',
    notSequenced: [
      {
        inventoryOwner: 'Summit Logistics',
        isActive: true,
        productAuthorizationId: 102,
        sequenceNumber: 0,
        supplierDirectedBlend: false,
      },
      {
        inventoryOwner: 'Horizon Trading',
        isActive: false,
        productAuthorizationId: 103,
        sequenceNumber: 0,
        supplierDirectedBlend: true,
      },
    ],
    product: {
      nameLong: 'Diesel',
    },
    productId: 203,
    sequenced: [
      {
        inventoryOwner: 'Apex Crude Corp',
        isActive: true,
        productAuthorizationId: 210,
        sequenceNumber: 1,
        supplierDirectedBlend: false,
      },
      {
        inventoryOwner: 'Global Industries',
        isActive: true,
        productAuthorizationId: 211,
        sequenceNumber: 2,
        supplierDirectedBlend: false,
      },
      {
        inventoryOwner: 'TechStart Inc',
        isActive: false,
        productAuthorizationId: 212,
        sequenceNumber: 3,
        supplierDirectedBlend: true,
      },
    ],
  },
  {
    loadingAllowed: true,
    locationId: 4,
    nameLong: 'Terminal 4 - San Antonio',
    notSequenced: [],
    product: {
      nameLong: 'Gasoline 91',
    },
    productId: 204,
    sequenced: [],
  },
  {
    loadingAllowed: false,
    locationId: 5,
    nameLong: 'Terminal 5 - Fort Worth',
    notSequenced: [
      {
        inventoryOwner: 'TechStart Inc',
        isActive: true,
        productAuthorizationId: 104,
        sequenceNumber: 0,
        supplierDirectedBlend: false,
      },
    ],
    product: {
      nameLong: 'Ethanol Blend',
    },
    productId: 205,
    sequenced: [
      {
        inventoryOwner: 'Innovative Solutions',
        isActive: true,
        productAuthorizationId: 213,
        sequenceNumber: 1,
        supplierDirectedBlend: false,
      },
    ],
  },
  {
    loadingAllowed: true,
    locationId: 6,
    nameLong: 'Terminal 6 - El Paso',
    notSequenced: [],
    product: {
      nameLong: 'Premium Diesel',
    },
    productId: 206,
    sequenced: [
      {
        inventoryOwner: 'Apex Crude Corp',
        isActive: true,
        productAuthorizationId: 214,
        sequenceNumber: 1,
        supplierDirectedBlend: false,
      },
      {
        inventoryOwner: 'Global Industries',
        isActive: false,
        productAuthorizationId: 215,
        sequenceNumber: 2,
        supplierDirectedBlend: false,
      },
    ],
  },
  {
    loadingAllowed: true,
    locationId: 1,
    nameLong: 'Houston International Distribution Terminal - North Facility',
    notSequenced: [
      {
        inventoryOwner: 'Summit Logistics',
        isActive: false,
        productAuthorizationId: 106,
        sequenceNumber: 0,
        supplierDirectedBlend: true,
      },
    ],
    product: {
      nameLong: 'Gasoline 91',
    },
    productId: 210,
    sequenced: [
      {
        inventoryOwner: 'TechStart Inc',
        isActive: true,
        productAuthorizationId: 216,
        sequenceNumber: 1,
        supplierDirectedBlend: false,
      },
    ],
  },
  {
    loadingAllowed: false,
    locationId: 1,
    nameLong: 'Houston International Distribution Terminal - North Facility',
    notSequenced: [],
    product: {
      nameLong: 'Ethanol Blend',
    },
    productId: 211,
    sequenced: [
      {
        inventoryOwner: 'Horizon Trading',
        isActive: false,
        productAuthorizationId: 217,
        sequenceNumber: 1,
        supplierDirectedBlend: true,
      },
      {
        inventoryOwner: 'Innovative Solutions',
        isActive: true,
        productAuthorizationId: 218,
        sequenceNumber: 2,
        supplierDirectedBlend: false,
      },
    ],
  },
  {
    loadingAllowed: true,
    locationId: 2,
    nameLong: 'Dallas-Fort Worth Complex',
    notSequenced: [],
    product: {
      nameLong: 'Diesel',
    },
    productId: 212,
    sequenced: [
      {
        inventoryOwner: 'Apex Crude Corp',
        isActive: true,
        productAuthorizationId: 219,
        sequenceNumber: 1,
        supplierDirectedBlend: false,
      },
      {
        inventoryOwner: 'Global Industries',
        isActive: true,
        productAuthorizationId: 220,
        sequenceNumber: 2,
        supplierDirectedBlend: false,
      },
    ],
  },
  {
    loadingAllowed: true,
    locationId: 2,
    nameLong: 'Dallas-Fort Worth Complex',
    notSequenced: [
      {
        inventoryOwner: 'TechStart Inc',
        isActive: true,
        productAuthorizationId: 107,
        sequenceNumber: 0,
        supplierDirectedBlend: false,
      },
    ],
    product: {
      nameLong: 'Premium Diesel',
    },
    productId: 213,
    sequenced: [
      {
        inventoryOwner: 'Summit Logistics',
        isActive: true,
        productAuthorizationId: 221,
        sequenceNumber: 1,
        supplierDirectedBlend: false,
      },
    ],
  },
  {
    loadingAllowed: false,
    locationId: 3,
    nameLong: 'Terminal 3 - Austin',
    notSequenced: [],
    product: {
      nameLong: 'Gasoline 87',
    },
    productId: 214,
    sequenced: [
      {
        inventoryOwner: 'Innovative Solutions',
        isActive: false,
        productAuthorizationId: 222,
        sequenceNumber: 1,
        supplierDirectedBlend: false,
      },
      {
        inventoryOwner: 'Apex Crude Corp',
        isActive: true,
        productAuthorizationId: 223,
        sequenceNumber: 2,
        supplierDirectedBlend: false,
      },
    ],
  },
  {
    loadingAllowed: true,
    locationId: 3,
    nameLong: 'Terminal 3 - Austin',
    notSequenced: [
      {
        inventoryOwner: 'Global Industries',
        isActive: true,
        productAuthorizationId: 108,
        sequenceNumber: 0,
        supplierDirectedBlend: false,
      },
      {
        inventoryOwner: 'TechStart Inc',
        isActive: true,
        productAuthorizationId: 109,
        sequenceNumber: 0,
        supplierDirectedBlend: true,
      },
    ],
    product: {
      nameLong: 'Ethanol Blend',
    },
    productId: 215,
    sequenced: [],
  },
  {
    loadingAllowed: true,
    locationId: 4,
    nameLong: 'Terminal 4 - San Antonio',
    notSequenced: [],
    product: {
      nameLong: 'Diesel',
    },
    productId: 216,
    sequenced: [
      {
        inventoryOwner: 'Apex Crude Corp',
        isActive: true,
        productAuthorizationId: 224,
        sequenceNumber: 1,
        supplierDirectedBlend: false,
      },
      {
        inventoryOwner: 'TechStart Inc',
        isActive: false,
        productAuthorizationId: 225,
        sequenceNumber: 2,
        supplierDirectedBlend: false,
      },
      {
        inventoryOwner: 'Global Industries',
        isActive: true,
        productAuthorizationId: 226,
        sequenceNumber: 3,
        supplierDirectedBlend: false,
      },
    ],
  },
  {
    loadingAllowed: true,
    locationId: 4,
    nameLong: 'Terminal 4 - San Antonio',
    notSequenced: [
      {
        inventoryOwner: 'Horizon Trading',
        isActive: false,
        productAuthorizationId: 110,
        sequenceNumber: 0,
        supplierDirectedBlend: true,
      },
    ],
    product: {
      nameLong: 'Premium Diesel',
    },
    productId: 217,
    sequenced: [
      {
        inventoryOwner: 'Summit Logistics',
        isActive: true,
        productAuthorizationId: 227,
        sequenceNumber: 1,
        supplierDirectedBlend: false,
      },
    ],
  },
  {
    loadingAllowed: false,
    locationId: 5,
    nameLong: 'Terminal 5 - Fort Worth',
    notSequenced: [],
    product: {
      nameLong: 'Gasoline 87',
    },
    productId: 218,
    sequenced: [
      {
        inventoryOwner: 'Global Industries',
        isActive: false,
        productAuthorizationId: 228,
        sequenceNumber: 1,
        supplierDirectedBlend: false,
      },
      {
        inventoryOwner: 'Apex Crude Corp',
        isActive: true,
        productAuthorizationId: 229,
        sequenceNumber: 2,
        supplierDirectedBlend: false,
      },
    ],
  },
  {
    loadingAllowed: true,
    locationId: 6,
    nameLong: 'Terminal 6 - El Paso',
    notSequenced: [
      {
        inventoryOwner: 'Innovative Solutions',
        isActive: true,
        productAuthorizationId: 111,
        sequenceNumber: 0,
        supplierDirectedBlend: false,
      },
    ],
    product: {
      nameLong: 'Gasoline 91',
    },
    productId: 219,
    sequenced: [
      {
        inventoryOwner: 'TechStart Inc',
        isActive: true,
        productAuthorizationId: 230,
        sequenceNumber: 1,
        supplierDirectedBlend: true,
      },
      {
        inventoryOwner: 'Summit Logistics',
        isActive: false,
        productAuthorizationId: 231,
        sequenceNumber: 2,
        supplierDirectedBlend: false,
      },
    ],
  },
  {
    loadingAllowed: true,
    locationId: 6,
    nameLong: 'Terminal 6 - El Paso',
    notSequenced: [],
    product: {
      nameLong: 'Diesel',
    },
    productId: 220,
    sequenced: [
      {
        inventoryOwner: 'Horizon Trading',
        isActive: true,
        productAuthorizationId: 232,
        sequenceNumber: 1,
        supplierDirectedBlend: false,
      },
    ],
  },
];

// Mock selector data
export const mockSelectors = [
  { id: 1, nameShort: 'Houston Terminal - North Facility', proprietary: false },
  { id: 2, nameShort: 'Dallas-Fort Worth Complex', proprietary: false },
  { id: 3, nameShort: 'Terminal 3 - Austin', proprietary: true },
  { id: 4, nameShort: 'Terminal 4 - San Antonio', proprietary: false },
  { id: 5, nameShort: 'Terminal 5 - Fort Worth', proprietary: false },
  { id: 6, nameShort: 'Terminal 6 - El Paso', proprietary: true },
  { id: 7, nameShort: 'Corpus Christi Terminal', proprietary: false },
  { id: 8, nameShort: 'Beaumont Storage Facility', proprietary: true },
  { id: 9, nameShort: 'Port Arthur Distribution Center', proprietary: false },
  { id: 10, nameShort: 'Galveston Bay Terminal', proprietary: false },
  { id: 11, nameShort: 'Midland Energy Hub', proprietary: true },
  { id: 12, nameShort: 'Lubbock Distribution Terminal', proprietary: false },
  { id: 13, nameShort: 'Amarillo Regional Depot', proprietary: false },
  { id: 14, nameShort: 'Waco Storage Complex', proprietary: true },
  { id: 15, nameShort: 'Tyler Terminal - East Texas', proprietary: false },
  { id: 16, nameShort: 'Laredo Border Terminal', proprietary: false },
  { id: 17, nameShort: 'Brownsville Distribution Hub', proprietary: true },
  { id: 18, nameShort: 'McAllen Storage Facility', proprietary: false },
];
